import api from "@/config/api";
import { Verification } from "@/types/verification";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const useQueryVerifications = () => {
    const { oid, sid, rid } = useParams<Params>();
    const enabled = !!(oid && sid && rid);

    const getVerifications = async () => {
        try {
            const data = await api.get<Verification[]>(
                `/organizations/${oid}/submissions/${sid}/reports/${rid}/verifications`,
            );

            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({
        queryKey: ["verifications", rid],
        queryFn: getVerifications,
        enabled,
    });
};

export default useQueryVerifications;
